// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","link":"keYOX cXdS1 hRgdS"};